"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _Dialog = _interopRequireDefault(require("@mui/material/Dialog"));

var _IconButton = _interopRequireDefault(require("@mui/material/IconButton"));

var _CobaltIcon = _interopRequireDefault(require("../CobaltIcon"));

var _system = require("@mui/system");

var _excluded = ["children", "onClose"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var CloseContainer = (0, _system.styled)('div')(function (_ref) {
  var _theme$components, _theme$components$Mui, _theme$components$Mui2;

  var theme = _ref.theme;
  return _objectSpread({}, (theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$Mui = _theme$components.MuiDialog) === null || _theme$components$Mui === void 0 ? void 0 : (_theme$components$Mui2 = _theme$components$Mui.styleOverrides) === null || _theme$components$Mui2 === void 0 ? void 0 : _theme$components$Mui2.close) || {});
});

var Dialog = function Dialog(props) {
  var children = props.children,
      onClose = props.onClose,
      others = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_Dialog["default"], (0, _extends2["default"])({
    onClose: onClose
  }, others), children, /*#__PURE__*/_react["default"].createElement(CloseContainer, null, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    onClick: function onClick(e) {
      return typeof onClose !== 'undefined' && onClose(e, 'backdropClick');
    },
    disableRipple: true,
    size: "large",
    sx: {
      p: 1,
      color: 'inherit'
    }
  }, /*#__PURE__*/_react["default"].createElement(_CobaltIcon["default"], {
    name: "x"
  }))));
};

var _default = Dialog;
exports["default"] = _default;